import { func, oneOfType, object, string, bool } from 'prop-types'
import { kuiperClassNames, renderIcon } from '../../utils'

import './styles.scss'

const SearchBar = ({
  focused,
  onBlur,
  onFocus,
  onKeyDown,
  onKeyUp,
  onSearch,
  searchTerm = '',
  searchBarRef,
  track,
}) => {
  const onSearchBarBlur = () => {
    if (track) track('Filter: Search', { filtered: !!searchTerm })
    if (onBlur) onBlur()
  }

  return (
    <div className={kuiperClassNames('search-bar')}>
      {renderIcon('search', { height: 12, width: 12, ariaMode: 'hidden' })}
      <input
        onBlur={onSearchBarBlur}
        onChange={(e) => onSearch(e.target.value)}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        placeholder={
          focused
            ? 'Type to search, or browse below'
            : 'Search and browse filters'
        }
        ref={searchBarRef}
        type="text"
        value={searchTerm}
      />
      {searchTerm.length > 0 ? (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          className={kuiperClassNames('clear')}
          onClick={onSearch.bind(this, '')}
        >
          {renderIcon('close-sm', {
            height: 8,
            width: 8,
            ariaLabel: 'Clear search',
            ariaMode: 'presentational',
          })}
        </div>
      ) : undefined}
    </div>
  )
}

SearchBar.propTypes = {
  focused: bool,
  onBlur: func,
  onFocus: func,
  onKeyDown: func,
  onKeyUp: func,
  onSearch: func,
  searchBarRef: oneOfType([func, object]),
  searchTerm: string,
  track: func,
}

export default SearchBar
